import { render, staticRenderFns } from "./selfDetail.vue?vue&type=template&id=25acfd08&scoped=true&"
import script from "./selfDetail.vue?vue&type=script&lang=js&"
export * from "./selfDetail.vue?vue&type=script&lang=js&"
import style0 from "./selfDetail.vue?vue&type=style&index=0&id=25acfd08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25acfd08",
  null
  
)

export default component.exports